import React, { createContext, useEffect, useState } from "react";
import { initializeSocket } from "./socket";

export const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const newSocket = initializeSocket(token);
            setSocket(newSocket);

            const handleBeforeUnload = () => {
                newSocket.disconnect();
            };

            window.addEventListener("beforeunload", handleBeforeUnload);

            return () => {
                newSocket.disconnect();
                window.removeEventListener("beforeunload", handleBeforeUnload);
            };
        }
    }, []);

    return (
        <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
    );
};
